<template>
  <div class="layer-tem">
    <!-- 关闭按钮 -->
    <img
      :src="newClose"
      class="close-btn"
      alt=""
      @click="closeLayer"
    >
    <!-- 主内容 -->
    <div class="layer-main">
      <!-- 导航 -->
      <tab-nav
        :tabArr="tabArr"
        :parNavIndex="tabIndex"
        @index="tabIndexFn"
      ></tab-nav>
      <!-- 块 -->
      <div class="block-list">
        <div class="block-head">
          <div class="tit-wrap">
            <!-- 标题 -->
            <div class="tit">
              {{dateTypeArr[dateTypeIndex]}}警情排名
            </div>
            <!-- 下拉框 -->
            <div class="select-wrap">
              <Select
                v-model="typeIndex"
                transfer
                :word-wrap="true"
                style="width: 100px;margin-right: 10px;"
                placeholder="单位"
                @on-change="typeSelect"
              >
                <Option
                  v-for="(item, index) in typeArr"
                  :value="item.index"
                  :key="index"
                >
                  {{item.text}}
                </Option>
              </Select>
              <Select
                v-model="areaId"
                transfer
                :word-wrap="true"
                clearable
                style="width: 100px;margin-right: 10px;"
                placeholder="区域"
                @on-change="selectArea"
              >
                <Option
                  v-for="item in areaArr"
                  :value="item.id"
                  :key="item.id"
                >
                  {{item.name}}
                </Option>
              </Select>
            </div>
            <!-- 升序降序 -->
            <div
              class="order-wrap"
              @click="setOrder"
            >
              <span class="order-text">
                {{orderStatus?'升序':'降序'}}
              </span>
              <div class="order-i-wrap">
                <i
                  class="iconfont"
                  :class="{'active': orderStatus}"
                >&#xe615;</i>
                <i
                  class="iconfont"
                  :class="{'active': !orderStatus}"
                >&#xeaca;</i>
              </div>
            </div>
          </div>
          <!-- 今日、本周、本月 -->
          <div>
            <Select
              v-model="dateTypeIndex"
              transfer
              :word-wrap="true"
              style="width: 100px;margin-right: 10px;"
              @on-change="dateTypeSelect"
            >
              <Option
                v-for="(item, index) in dateTypeArr"
                :value="index"
                :key="index"
              >
                {{item}}
              </Option>
            </Select>
          </div>
        </div>
        <div class="block-main">
          <div class="block-main-content">
            <!-- echart图 -->
            <div
              class="echart"
              ref="echart"
              v-show="echartArr.length"
            ></div>
            <p
              class="no-data"
              v-show="!echartArr.length && getEchartStatus"
            >
              暂无数据
            </p>
          </div>
        </div>
      </div>
      <!-- 块 -->
      <div class="block-list">
        <div class="block-head block-head-text">
          <div class="tit-wrap">
            <!-- 标题 -->
            <div class="tit">
              {{parTit}}警情信息
            </div>

          </div>
          <div class="right-form-wrap">
            <!-- 消防负责人 单位显示，行业隐藏 -->
            <div
              class="text"
              v-show="typeIndex == 0"
            >
              消防负责人：{{titleTextObj.chargePersonName}}
            </div>
            <!-- 联系方式 单位显示，行业隐藏 -->
            <div
              class="text"
              v-show="typeIndex == 0"
            >
              联系方式：{{titleTextObj.chargePersonTel}}
            </div>
            <!-- 状态名称 -->
            <Select
              v-model="statusTypeCode"
              transfer
              :word-wrap="true"
              clearable
              style="width: 100px;margin-right: 10px;"
              @on-change="statusSelect"
            >
              <Option
                v-for="(item, index) in statusType"
                :value="item.code"
                :key="index"
              >
                {{ item.text }}
              </Option>
            </Select>
          </div>
        </div>
        <div class="block-main">
          <!-- 列表 滚动加载更多 -->
          <div class="block-main-content">
            <!-- 列表 滚动加载更多 -->
            <div class="table-wrap">
              <div class="table-head">
                <table>
                  <tr v-if="typeIndex == 0">
                    <th width="5%">
                      序号
                    </th>
                    <th width="20%">
                      {{tabArr[tabIndex]}}发生时间
                    </th>
                    <th width="15%">
                      设备名称
                    </th>
                    <th width="20%">
                      警情内容
                    </th>
                    <th width="10%">
                      处理状态
                    </th>
                    <th width="10%">
                      操作人
                    </th>
                    <th width="20%">
                      操作时间
                    </th>
                  </tr>
                  <tr v-if="typeIndex == 1">
                    <th width="10%">
                      序号
                    </th>
                    <th width="30%">
                      单位名称
                    </th>
                    <th width="30%">
                      区域
                    </th>
                    <th width="30%">
                      {{tabArr[tabIndex]}}数量
                    </th>
                  </tr>
                </table>
              </div>
              <div
                class="table-body"
                id="layer-tem-midTop"
              >
                <table v-show="typeIndex == 0">
                  <tr
                    v-for="(item, index) in tableListArr"
                    :key="index"
                  >
                    <td width="5%">
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="index + 1"
                      >
                        {{index + 1}}
                      </Poptip>
                    </td>
                    <td width="20%">
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="timestamp(item.ctime)"
                        v-if="item.ctime"
                      >
                        {{timestamp(item.ctime)}}
                      </Poptip>
                    </td>
                    <td width="15%">
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.deviceName"
                        v-if="item.deviceName"
                      >
                        {{item.deviceName}}
                      </Poptip>
                    </td>
                    <td width="20%">
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.content"
                        v-if="item.content"
                      >
                        {{item.content}}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.state"
                        v-if="item.state"
                      >
                        {{item.state}}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.operator"
                        v-if="item.operator"
                      >
                        {{item.operator}}
                      </Poptip>
                    </td>
                    <td width="20%">
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="timestamp(item.htime)"
                        v-if="item.htime"
                      >
                        {{timestamp(item.htime)}}
                      </Poptip>
                    </td>
                  </tr>
                </table>
                <table v-show="typeIndex == 1">
                  <tr
                    v-for="(item, index) in tableListArr"
                    :key="index"
                  >
                    <td width="10%">
                      {{index + 1}}
                    </td>
                    <td width="30%">
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.name"
                        v-if="item.name"
                      >
                        {{item.name}}
                      </Poptip>
                    </td>
                    <td width="30%">
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.areaName"
                        v-if="item.areaName"
                      >
                        {{item.areaName}}
                      </Poptip>
                    </td>
                    <td width="30%">
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.value"
                        v-if="item.value"
                      >
                        {{item.value}}
                      </Poptip>
                    </td>
                  </tr>
                </table>
                <p
                  class="no-data"
                  v-show="(!tableListArr.length && getTableStatus) || (!echartArr.length)"
                >
                  暂无数据
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import newClose from "@/assets/img/newClose.png";
import tabNav from "./tab-nav.vue";
import { themeArr } from "@/assets/js/theme.js";
import { getTime, returnDay, timestampToTime } from "@/assets/js/index";
export default {
  name: "",
  data: () => ({
    newClose,
    tabArr: ["火警", "报警", "预警", "隐患", "故障"],
    tabIndex: 0,
    hashValue: "",
    loginData: {},
    currentPage: 1,
    typeArr: [
      {
        text: "单位",
        index: 0,
      },
      {
        text: "行业",
        index: 1,
      },
    ],
    typeIndex: 0,
    areaArr: [],
    areaId: "",
    parTit: "",
    timeSelet: "",
    deviceId: "",
    deviceArr: [],
    dateTypeArr: ["今日", "本周", "本月"],
    dateTypeIndex: 0,
    statusType: [],
    statusTypeCode: "",
    titleTextObj: {
      chargePersonName: "",
      chargePersonTel: "",
    },
    echartDom: null,
    tableField: [
      {
        th: "单位名称",
        td: "departName",
      },
      {
        th: "单位地址",
        td: "departName",
      },
      {
        th: "责任人",
        td: "departName",
      },
      {
        th: "联系方式",
        td: "departName",
      },
      {
        th: "分数",
        td: "departName",
      },
      {
        th: "详情",
        td: "departName",
      },
    ],
    tableGetDataObj: {},
    tableUrl: "",
    echarts_color: themeArr[0].color,

    orderStatus: false,
    tableListArr: [],
    totalCount: "",
    tableDepId: "",
    getEchartStatus: false,
    echartArr: [],
    getTableStatus: false,
    beginTime: "",
    endTime: "",
  }),
  components: {
    tabNav,
  },
  watch: {
    headDateIndex: {
      handler(res, oldVal) {
        console.log(res);
        console.log("头部日期选择");
        this.dateTypeIndex = res;

        //获取echart数据
        this.getEchartData();
      },
      //   immediate: true,
      deep: true,
    },
    layerNavIndex: {
      handler(res, oldVal) {
        console.log(res);
        console.log("类型索引");
        this.tabIndex = res;
        switch (res) {
          case 0: //火警、报警
          case 1:
            this.statusType = [
              {
                text: "未处理",
                code: "0,1",
              },
              {
                text: "报修",
                code: "3",
              },
              {
                text: "已处理",
                code: "2",
              },
            ];
            this.statusTypeCode = "";
            break;
          case 2:
          case 3:
          case 4:
            this.statusType = [
              {
                text: "未处理",
                code: "0",
              },
              {
                text: "报修",
                code: "3",
              },
              {
                text: "已处理",
                code: "2",
              },
            ];
            this.statusTypeCode = "";
            break;
        }
        //获取echart数据
        this.getEchartData();
      },
      // immediate: true,
      deep: true,
    },
    comTypeIndex: {
      //单位，行业
      handler(res, oldVal) {
        console.log(res);
        console.log("单位，行业索引");
        this.typeIndex = res;
        //获取echart数据
        this.getEchartData();
      },
      // immediate: true,
      deep: true,
    },
  },
  created() {
    this.hashValue = localStorage.getItem("hashValue");
    this.loginData = JSON.parse(localStorage.getItem("loginData"));
    this.tabIndex = this.$store.state.showLayer.navIndex;
    switch (this.tabIndex) {
      case 0: //火警、报警
      case 1:
        this.statusType = [
          {
            text: "未处理",
            code: "0,1",
          },
          {
            text: "报修",
            code: "3",
          },
          {
            text: "已处理",
            code: "2",
          },
        ];
        this.statusTypeCode = "";
        break;
      case 2:
      case 3:
      case 4:
        this.statusType = [
          {
            text: "未处理",
            code: "0",
          },
          {
            text: "报修",
            code: "3",
          },
          {
            text: "已处理",
            code: "2",
          },
        ];
        this.statusTypeCode = "";
        break;
    }
    this.dateTypeIndex = this.$store.state.headDate.index;
  },
  mounted() {
    //获取区域
    this.getAreaData();
    // 获取echart数据
    this.getEchartData();
  },
  computed: {
    headDateIndex() {
      return this.$store.state.headDate.index;
    },
    layerNavIndex() {
      return this.$store.state.showLayer.navIndex;
    },
    comTypeIndex() {
      return this.$store.state.showLayer.comTypeIndex;
    },
  },
  methods: {
    timestamp(time) {
      return timestampToTime(time);
    },
    dataInit() {
      if (this.echartDom) {
        this.echartDom.clear();
      }
      this.tableListArr = [];
      this.totalCount = "";
    },
    setOrder() {
      this.orderStatus = !this.orderStatus;
      //获取echart
      this.getEchartData();
    },
    closeLayer() {
      this.$store.commit("showLayer", {
        status: false,
        type: "",
      });
    },
    tabIndexFn(tabIndex) {
      //导航切换
      this.tabIndex = tabIndex;
      this.typeIndex = 0; //默认选择单位
      switch (tabIndex) {
        case 0: //火警、报警
        case 1:
          this.statusType = [
            {
              text: "未处理",
              code: "0,1",
            },
            {
              text: "报修",
              code: "3",
            },
            {
              text: "已处理",
              code: "2",
            },
          ];
          this.statusTypeCode = "";
          break;
        case 2:
        case 3:
        case 4:
          this.statusType = [
            {
              text: "未处理",
              code: "0",
            },
            {
              text: "报修",
              code: "3",
            },
            {
              text: "已处理",
              code: "2",
            },
          ];
          this.statusTypeCode = "";
          break;
      }
      //获取echart
      this.getEchartData();
    },
    typeSelect() {
      //单位行业下拉
      //获取echart
      this.getEchartData();
    },
    selectArea() {
      //区域下拉
      //获取echart
      this.getEchartData();
    },
    dateTypeSelect() {
      //日期类型下拉
      //获取echart
      this.getEchartData();
    },
    statusSelect() {
      //状态下拉
      //初始化数据
      (this.currentPage = 1), (this.tableListArr = []);
      this.titleTextObj = {
        chargePersonName: "",
        chargePersonTel: "",
      };
      $JQ("#layer-tem-midTop").mCustomScrollbar("update");
      this.$nextTick(() => {
        //获取table
        this.getTableData();
      });
    },
    getAreaData() {
      let dataObj = {
        type: "get",
        // url: '/mcbw/areas/' + this.loginData.orgId,
        url: "/mcbw/departments/org/area",
        obj: {
          pageSize: 1000,
          currentPage: 1,
          // areaId: this.loginData.areaId
        },
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("区域数据");
        if (res.data.success && res.data.data.length) {
          this.areaArr = res.data.data;
        }
      });
    },
    getEchartData() {
      $JQ("#layer-tem-midTop").mCustomScrollbar("update");
      this.getEchartStatus = false;
      if (this.echartDom) {
        this.echartDom.clear();
      }
      let dateType = "";
      (this.currentPage = 1), (this.tableListArr = []);
      this.parTit = "";
      this.titleTextObj = {
        chargePersonName: "",
        chargePersonTel: "",
      };
      switch (this.dateTypeIndex) {
        case 0: //日
          dateType = "thisDay";
          break;
        case 1: //周
          dateType = "thisWeek";
          break;
        case 2: //月
          dateType = "thisMonth";
          break;
      }
      let type = "";
      switch (this.tabIndex) {
        case 0:
          type = "flamingFire";
          break;
        case 1:
          type = "fire";
          break;
        case 2:
          type = "warn";
          break;
        case 3: //隐患
          type = "hiddenHazard";
          break;
        case 4: //故障
          type = "fault";
          break;
      }
      let dataObj = {
        type: "get",
        url: this.typeIndex
          ? "/mcbw/dep_stats/event/depType/count"
          : "/mcbw/dep_stats/event/depId/count", //行业 单位
        obj: {
          dateType,
          type,
          sortType: this.orderStatus ? "ASC" : "DESC",
          pageSize: 100,
          currentPage: 1,
          areaId: this.areaId || null,
        },
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("ecahrt数据");
        this.getEchartStatus = true;
        this.echartArr = res.data.data;
        if (res.data.success && res.data.data.length) {
          this.$nextTick(() => {
            this.chartInit(res.data.data);
          });
          this.parTit = res.data.data[0].name;
          this.tableDepId = res.data.data[0].depId || res.data.data[0].depType;
          this.getTableData();
        }
      });
    },
    chartInit(data) {
      //左上图
      let that = this;
      let option = {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            // console.log(params[0]);
            let res = `<div><span style="display: inline-block;width:10px;height:10px;margin-right:5px;background:none;"></span>${
              that.typeIndex ? "行业" : "单位"
            }：${data[params[0].dataIndex].name}</div>`;
            res += `<p><span style="display: inline-block;width:10px;height:10px;margin-right:5px;border-radius:10px;background:#fd6760;"></span>${
              that.tabArr[that.tabIndex]
            }：${params[0].value}</p>`;
            return res;
          },
          textStyle: {
            color: that.echarts_color,
          },
          confine: true,
        },
        calculable: true,
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "15%",
          containLabel: true,
        },
        dataZoom: data.length > 10 ? [
            {
                type: 'slider',
                start: 0,
                end: 30,
                height:8,
                bottom:0,
                fillerColor: '#74d9ff',
            }
        ] : [],
        xAxis: [
          {
            type: "category",
            data: that.name_substr(data, "name"),
            axisLine: {
              show: true,
              lineStyle: {
                color: "#122856",
              },
            },
            axisLabel: {
              textStyle: {
                color: that.echarts_color,
              },
              interval: 0,
              fontSize: 10,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                color: that.echarts_color,
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "transparent",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#122856",
              },
            },
          },
        ],
        series: [
          {
            name: that.right_bot_click_text + "数",
            type: "bar",
            data: that.name_substr(data, "value"),
            barWidth: 30,
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#fd6760", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#fd6760", // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };
      let _this = this;
      this.echartDom = this.$echarts.init(this.$refs.echart);
      this.echartDom.setOption(option);
      this.echartDom.off("click");
      this.echartDom.on("click", function (params) {
        console.log(params);
        _this.parTit = params.data.name;
        _this.tableDepId = params.data.depId;
        (_this.currentPage = 1), (_this.tableListArr = []);
        _this.titleTextObj = {
          chargePersonName: "",
          chargePersonTel: "",
        };
        _this.getTableData();
      });
    },
    name_substr(data, type) {
      let name_arr = [];
      let value_arr = [];
      for (let i = 0; i < data.length; i++) {
        if (data.length < 4 || data[i].name.length <= 4) {
          name_arr.push(data[i].name);
        } else {
          name_arr.push(data[i].name.substr(0, 4) + "...");
        }
        value_arr.push({
          value: data[i].count,
          depId: data[i].depId || data[i].depType,
          name: data[i].name,
        });
      }
      if (type == "name") {
        return name_arr;
        //这里进行一下字数限制，如果大于4个字，就省略号显示
      } else {
        return value_arr;
      }
    },
    weekDate() {
      //本周时间
      var date = new Date();
      // 本周一的日期
      date.setDate(
        date.getDate() - (date.getDay() == 0 ? 7 : date.getDay()) + 1
      );
      var begin =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " 00:00:00";
      // 本周日的日期
      date.setDate(date.getDate() + 6);
      var end =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " 23:59:59";
      return [begin, end];
    },
    monthDate() {
      let date = new Date();
      let currentMonth = date.getMonth();
      let nextMonth = ++currentMonth;
      let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      let oneDay = 1000 * 60 * 60 * 24;
      let end =
        new Date(nextMonthFirstDay - oneDay)
          .toLocaleDateString()
          .replace(/\//g, "-") + " 23:59:59";
      let begin =
        new Date(date.setDate(1)).toLocaleDateString().replace(/\//g, "-") +
        " 00:00:00";
      return [begin, end];
    },
    getTimeFn(index) {
      switch (index) {
        case 0: //今日
          let _beginTime =
            new Date().toLocaleDateString().replace(/\//g, "-") + " 00:00:00";
          let _endTime =
            new Date().toLocaleDateString().replace(/\//g, "-") + " 23:59:59";
          this.beginTime = new Date(_beginTime).getTime();
          this.endTime = new Date(_endTime).getTime();
          break;
        case 1: //本周
          this.beginTime = new Date(this.weekDate()[0]).getTime();
          this.endTime = new Date(this.weekDate()[1]).getTime();
          break;
        case 2: //本月
          this.beginTime = new Date(this.monthDate()[0]).getTime();
          this.endTime = new Date(this.monthDate()[1]).getTime();
          break;
      }
    },
    getDepartDetail() {
      let dataObj = {
        type: "get",
        url: "/mcbw/departments/" + this.tableDepId,
        obj: {},
      };
      this.$Axios(dataObj).then((res) => {
        if (res.data.success) {
          this.titleTextObj = {
            chargePersonName: res.data.data.leader,
            chargePersonTel: res.data.data.leaderPhone,
          };
        }
      });
    },
    getTableData() {
      //获取表格数据
      //获取单位详情
      if (!this.typeIndex) {
        this.getDepartDetail();
      }
      this.getTableStatus = false;
      let url = "";
      let obj = "";
      if (this.typeIndex) {
        //行业
        let dateType = "";
        switch (this.dateTypeIndex) {
          case 0: //日
            dateType = "thisDay";
            break;
          case 1: //周
            dateType = "thisWeek";
            break;
          case 2: //月
            dateType = "thisMonth";
            break;
        }
        let type = "";
        switch (this.tabIndex) {
          case 0:
            type = "flamingFire";
            break;
          case 1:
            type = "fire";
            break;
          case 2:
            type = "warn";
            break;
          case 3: //隐患
            type = "hiddenHazard";
            break;
          case 4: //故障
            type = "fault";
            break;
        }
        url = "/mcbw/dep_stats/event/state_count";
        obj = {
          dateType: dateType,
          type: type,
          industryCategory: this.tableDepId,
          states: this.statusTypeCode || null,
          sortType: "DESC",
          pageSize: 100,
          currentPage: this.currentPage,
          areaId: this.areaId || null,
        };
      } else {
        //单位
        this.getTimeFn(this.dateTypeIndex); //获取beginTim，endTime
        switch (this.tabIndex) {
          case 0: //火警
            url = "/mcbw/alarm_manage/fire";
            obj = {
              sources: "3,6,7",
              pageSize: 50,
              currentPage: this.currentPage,
              orgId: this.tableDepId,
              beginTime: this.beginTime,
              endTime: this.endTime,
              state: this.statusTypeCode || null,
              type: null,
              content: null,
            };
            if (this.statusTypeCode == "0,1") {
              obj["states"] = "0,1";
              delete obj["state"];
            }
            break;
          case 1: //报警
            url = "/mcbw/alarm_manage/fire";
            obj = {
              pageSize: 50,
              currentPage: this.currentPage,
              orgId: this.tableDepId,
              beginTime: this.beginTime,
              endTime: this.endTime,
              state: this.statusTypeCode || null,
              type: null,
              content: null,
            };
            if (this.statusTypeCode == "0,1") {
              obj["states"] = "0,1";
              delete obj["state"];
            }
            break;
          case 2: //预警
            url = "/mcbw/alarm_manage/warn";
            obj = {
              pageSize: 50,
              currentPage: this.currentPage,
              orgId: this.tableDepId,
              beginTime: this.beginTime,
              endTime: this.endTime,
              state: this.statusTypeCode || null,
              type: null,
              content: null,
            };
            break;
          case 3: //隐患
            url = "/mcbw/hidden_hazard";
            obj = {
              pageSize: 50,
              currentPage: this.currentPage,
              orgId: this.tableDepId,
              beginTime: this.beginTime,
              endTime: this.endTime,
              state: this.statusTypeCode || null,
              type: null,
              content: null,
            };
            break;
          case 4: //故障
            url = "/mcbw/alarm_manage/fault";
            obj = {
              pageSize: 50,
              currentPage: this.currentPage,
              orgId: this.tableDepId,
              beginTime: this.beginTime,
              endTime: this.endTime,
              state: this.statusTypeCode || null,
              type: null,
              content: null,
            };
            break;
        }
      }
      let dataObj = {
        type: "get",
        url,
        obj,
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("table表格数据");
        this.getTableStatus = true;
        if (res.data.success) {
          if (res.data.totalCount) {
            this.totalCount = res.data.totalCount;
          }
          if (!res.data.data.length) {
            return;
          }
          this.tableListArr = [...this.tableListArr, ...res.data.data];
          let _this = this;
          this.$nextTick(() => {
            $JQ("#layer-tem-midTop").mCustomScrollbar({
              callbacks: {
                onTotalScroll: function () {
                  if (
                    _this.tableListArr.length == res.data.totalCount ||
                    res.data.data.length == 0
                  ) {
                    console.log("没有更多数据");
                    return;
                  } else {
                    console.log("加载更多");
                    _this.currentPage += 1;
                    _this.getTableData();
                  }
                },
              },
            });
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.layer-tem {
  position: absolute;
  left: 500px;
  bottom: 0;
  width: calc(100% - 1000px);
  // height: 500px;
  padding: 30px 25px;
  background: rgba(6, 18, 44, 1) url("../../assets/img/maskBg.png") center
    center/101% 102% no-repeat;
  z-index: 12;

  // 关闭按钮
  .close-btn {
    position: absolute;
    right: 0;
    top: 0;
    right: 25px;
    top: 30px;
    cursor: pointer;
  }
  .block-head {
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.block-head-form {
      justify-content: space-between;
    }
    &.block-head-text {
      color: #a2d8ff;
      .text {
        margin-right: 20px;
      }
    }
    .tit {
      min-width: 150px;
      margin-right: 20px;
    }
    .tit-wrap {
      display: flex;
      align-items: center;
      .order-wrap {
        display: flex;
        align-items: center;
        color: #74d9ff;
        cursor: pointer;
        .order-i-wrap {
          display: flex;
          flex-direction: column;
          i:first-child {
            margin-bottom: -16px;
          }
          i {
            opacity: 0.5;
            &.active {
              opacity: 1;
            }
          }
        }
      }
    }
    .right-form-wrap {
      display: flex;
      align-items: center;
    }
  }
  .block-main {
    height: 200px;
    position: relative;
    padding: 8px;

    .block-main-content {
      height: 100%;
      .echart {
        height: 100%;
      }
      .no-data {
        height: 184px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ddd;
      }
      .table-wrap {
        height: 100%;
        display: flex;
        flex-direction: column;
        .table-head {
          background: #0c2745;
          color: #7db4db;
          table th {
            height: 30px;
          }
        }
        .table-body {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          color: #e4eff5;
          table td {
            text-align: center;
            height: 30px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            i {
              cursor: pointer;
            }
            i.imgView {
              color: rgba(125, 180, 219, 0.7);
              cursor: pointer;
              &.active {
                color: rgba(125, 180, 219, 0.3);
                cursor: default;
              }
            }
            .td-option-wrap {
              display: flex;
              align-items: center;
              justify-content: center;
              i {
                margin: 0 10px;
                color: rgba(8, 244, 247, 0.3);
                cursor: default;
                &.active {
                  color: rgba(8, 244, 247, 0.7);
                  cursor: pointer;
                }
              }
            }
          }
          table tr:nth-child(2n) {
            background: #0c2745;
          }
          .no-data {
            height: 152px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ddd;
          }
        }
        table {
          width: 100%;
          table-layout: fixed;
          border-collapse: collapse;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/layer/rightMid.vue